import React from 'react';
import { connect } from 'react-redux';
// components
import CampaignForm from './CampaignForm';
import SelectOffer from './SelectOffer';
import OtpVerification from '../../mobile/components/Auth/OtpVerification';
import ProgressBar from '../ProgressBar/ProgressBar';
import OfferUnlockSuccess from './OfferUnlockSuccess';
import {
  sendCampaignUserData,
  firstDealUserExists,
  checkUserExists,
  resetCampaignUserData,
} from '../../actionCreators/offerCampaign';
import { sendValidateOtp } from '../../actionCreators/auth';
import sessionStorageHelper from '../../utils/sessionStorageHelper';
import { showElement, getQueryParam, getUtmParameters } from '../../utils/helper';
import { setAndTriggerDataLayer, pushDataLayerEvent } from '../../utils/DataLayer';
import OfferItem from './OfferItem';

/** Props: isDesktop: If true, it is Desktop mode else Mobile mode */
class OfferCampaign extends React.PureComponent {
  constructor(props) {
    super(props);
    this.selectOffer = this.selectOffer.bind(this);
    this.updateStep = this.updateStep.bind(this);
    this.submitOfferForm = this.submitOfferForm.bind(this);
    this.changeNumber = this.changeNumber.bind(this);
    this.otpVerifySuccess = this.otpVerifySuccess.bind(this);
    this.checkUserExistsFunc = this.checkUserExistsFunc.bind(this);
    this.getSkipUrl = this.getSkipUrl.bind(this);
    this.checkRepeatUser = this.checkRepeatUser.bind(this);
    this.prevStep = null;
    this.phone = null;
    this.checkFirstDealUser = false;
    this.state = {
      step: 1,
      userPhone: null,
      persistFormValue: null,
      offerConfig: null,
      offerItem: null,
    };
    this.gtm = {
      event: 'lead form',
      pageName: 'offer lead',
      pageType: 'lead form',
      category: '',
      channel: '',
      subSection1: '',
      PageUrl: '',
    };
    this.pdpFlow = false;
    this.isRepeatUser = null;
  }
  componentDidMount() {
    const { history, isDesktop, redisCommonData, location, login } = this.props;
    this.prevStep = getQueryParam(location?.search?.substr(1), 'step') || 1;
    if (this.prevStep === '3' && !isDesktop) {
      history.push({ pathname: '/', search: '' });
    }
    const offerConfig =
      redisCommonData &&
      redisCommonData.IPL_OFFER_CONFIG &&
      JSON.parse(redisCommonData.IPL_OFFER_CONFIG);
    (() => {
      this.setState({ step: parseInt(this.prevStep, 10), offerConfig });
    })();
    this.pdpFlow = location?.search && location.search.includes('pdfFlow');
    this.isRepeatUser = this.checkRepeatUser();
    Object.assign(this.gtm, {
      PageUrl: window?.location.href || '',
      LkUserType: this.isRepeatUser ? 'lkRepeat' : 'lkNew',
      loginStatus: login ? 'loggedIn' : 'guest',
    });
    pushDataLayerEvent(this.gtm);
    this.triggerTrackingEvents();
  }
  componentDidUpdate(prevProps) {
    const {
      isFirstDealUser,
      firstDealUserExists,
      login,
      history,
      isDesktop,
      campaignUserData,
      userInfo,
      triggerAuthModal,
      sendValidateOtp,
      redisCommonData,
      resetCampaignUserData,
    } = this.props;
    const { userPhone, step, offerConfig, offerItem } = this.state;
    if (login) this.isRepeatUser = this.checkRepeatUser();
    this.phone = userInfo?.telephone || null;
    if (!this.checkFirstDealUser && !this.pdpFlow && login && this.phone && !isDesktop) {
      firstDealUserExists(this.phone);
      this.checkFirstDealUser = true;
    }
    window.onpopstate = function () {
      if (!isDesktop) history.push({ pathname: '/', search: '' });
    };
    showElement('#app-footer', false);
    const selectedCategory = this.selectedOffer?.cat_name;
    if (!isDesktop && prevProps.campaignUserData !== campaignUserData && campaignUserData) {
      const data = {
        data: { username: userPhone },
        type: 'SEND_OTP',
      };
      if (login) {
        this.updateStep(4);
        Object.assign(this.gtm, {
          pageName: 'success lead',
          category: selectedCategory || '',
          PageUrl: window?.location.href || '',
          LkUserType: this.isRepeatUser ? 'lkRepeat' : 'lkNew',
          loginStatus: 'loggedIn',
        });
        pushDataLayerEvent(this.gtm);
      } else {
        sendValidateOtp(data);
        this.updateStep(3);
        Object.assign(this.gtm, {
          pageName: 'otp lead',
          category: selectedCategory || '',
          PageUrl: window?.location.href || '',
          LkUserType: 'lkNew',
          loginStatus: 'guest',
        });
        pushDataLayerEvent(this.gtm);
      }
    }
    // Wheh user loggedIn/Registered successfully and offer form filled (isFirstDealUser: true)
    // or campaignUserData call succeed
    // Open step 4 (success screen) and close auth modal
    if (isDesktop && login && step !== 4 && isFirstDealUser && campaignUserData) {
      Object.assign(this.gtm, {
        pageName: 'success lead',
        category: selectedCategory || '',
        PageUrl: window?.location.href || '',
        LkUserType: this.isRepeatUser ? 'lkRepeat' : 'lkNew',
        loginStatus: 'loggedIn',
      });
      pushDataLayerEvent(this.gtm);
      this.updateStep(4);
      triggerAuthModal(false);
      resetCampaignUserData();
    }
    this.selectedOffer = sessionStorageHelper.getItem('offerSelected') || null;
    if (!offerConfig) {
      const offerConfig =
        redisCommonData &&
        redisCommonData.IPL_OFFER_CONFIG &&
        JSON.parse(redisCommonData.IPL_OFFER_CONFIG);
      (() => {
        this.setState({ offerConfig });
      })();
    }
    if (this.pdpFlow && !offerItem) {
      const getOfferItem = sessionStorageHelper.getItem('pdfOffer') || null;
      (() => {
        this.setState({ offerItem: getOfferItem });
      })();
    }
  }
  componentWillUnmount() {
    showElement('#app-footer', true);
  }

  getSkipUrl(cat_PLP_url, cat_ar_url) {
    const { offerConfig } = this.state;
    const { AR, enable_3D } = offerConfig || {};
    let landingUrl;
    if (enable_3D === 'ON') {
      if (AR === 'ON') {
        landingUrl = cat_ar_url;
      } else {
        landingUrl = cat_PLP_url;
      }
    } else if (AR === 'ON') {
      landingUrl = cat_ar_url;
    } else {
      landingUrl = cat_PLP_url;
    }
    return landingUrl;
  }
  checkRepeatUser() {
    const { userInfo } = this.props;
    if (userInfo && userInfo.hasPlacedOrder) {
      return true;
    }
    return false;
  }
  selectOffer(offer) {
    const { isDesktop, triggerAuthModal, isFirstDealUser, hasPlacedOrder, login } = this.props;
    const { cat_PLP_url, cat_ar_url, cat_name } = offer;
    if (login) this.isRepeatUser = this.checkRepeatUser();
    const skipUrl = this.getSkipUrl(cat_PLP_url, cat_ar_url);
    sessionStorageHelper.setItem('offerSelected', offer);
    if (!isDesktop) {
      if (isFirstDealUser) {
        window.location.href = skipUrl;
      } else {
        this.updateStep(2);
        Object.assign(this.gtm, {
          pageName: 'form lead',
          category: cat_name || '',
          PageUrl: window?.location.href || '',
          LkUserType: this.isRepeatUser ? 'lkRepeat' : 'lkNew',
          loginStatus: login ? 'loggedIn' : 'guest',
        });
        pushDataLayerEvent(this.gtm);
      }
    }
    // If user already placed order then navigate to plp_url
    // Else open the auth modal
    if (isDesktop) {
      // If already placed order or already filled firstDeal form
      if (hasPlacedOrder || isFirstDealUser) {
        window.location.href = cat_PLP_url;
      } else if (triggerAuthModal) {
        Object.assign(this.gtm, {
          pageName: 'form lead',
          category: cat_name || '',
          PageUrl: window?.location.href || '',
          LkUserType: this.isRepeatUser ? 'lkRepeat' : 'lkNew',
          loginStatus: login ? 'loggedIn' : 'guest',
        });
        pushDataLayerEvent(this.gtm);
        triggerAuthModal(true);
      }
    }
  }
  updateStep(step) {
    const { history, isDesktop, setStepOfferCampaign } = this.props;
    this.setState({ step });
    if (!isDesktop) {
      history.push({
        pathname: '/offer-unlock',
        search: `?step=${step}${this.pdpFlow ? '&pdfFlow' : ''}`,
      });
    } else {
      setStepOfferCampaign(step);
    }
  }
  submitOfferForm(formData) {
    const { sendCampaignUserData } = this.props;
    const { mobileNumber, email, name, gender } = formData || {};
    const userPhone = this.phone || mobileNumber;
    this.setState({ userPhone });
    const selectedCategory = this.selectedOffer?.cat_name;
    const finalData = {
      email: email || '',
      gender: gender || '',
      mobileNumber: userPhone || '',
      name: name || '',
      category: selectedCategory || '',
    };
    sendCampaignUserData(finalData);
  }
  changeNumber() {
    const { campaignUserData } = this.props;
    this.updateStep(2);
    this.setState({ persistFormValue: campaignUserData });
  }
  otpVerifySuccess() {
    this.updateStep(4);
    const selectedCategory = this.selectedOffer?.cat_name;
    Object.assign(this.gtm, {
      pageName: 'success lead',
      category: selectedCategory || '',
      PageUrl: window?.location.href || '',
      LkUserType: this.isRepeatUser ? 'lkRepeat' : 'lkNew',
      loginStatus: this.props.login ? 'loggedIn' : 'guest',
    });
    pushDataLayerEvent(this.gtm);
  }
  checkUserExistsFunc(val) {
    this.props.checkUserExists(val);
  }

  triggerTrackingEvents() {
    const { localeInfo } = this.props;
    const { domain } = localeInfo;
    if (document.readyState === 'complete') {
      const { fbq, location } = window;
      if (typeof fbq !== 'undefined') {
        fbq('track', 'PageView');
      }
      /** Data Layer Starts */
      const dlUpdate = {};
      const utmParameters = getUtmParameters();
      dlUpdate.visitorStore = `${domain}`;
      dlUpdate.visitorPageTypeInfo = 'Static';
      dlUpdate.visitorPageType = 'Offer-Unlock';
      dlUpdate.PageUrl = location.href;
      dlUpdate.utmSource = utmParameters.utmSourceValue || '';
      dlUpdate.utmCampaign = utmParameters.utmCamValue || '';
      dlUpdate.utmMedium = utmParameters.utmMediumValue || '';
      dlUpdate.utmTerm = utmParameters.utmTermValue || '';
      dlUpdate.utmContent = utmParameters.utmContentValue || '';
      setAndTriggerDataLayer(dlUpdate);
      /** Data Layer Ends */
    } else {
      setTimeout(() => {
        this.triggerTrackingEvents();
      }, 2000);
    }
  }

  render() {
    const { step, userPhone, persistFormValue = {}, offerConfig, offerItem } = this.state;
    const {
      login,
      saveUserDataLoading,
      redisCommonData,
      isUserExists,
      history,
      isDesktop,
      isDesktopPdp,
      dataLocale,
      dataLocale: { SELECT_OFFER, WHO_ARE_YOU_SHOPPING_FOR, LAST_STEP_ENTER_OTP },
      currencyMark,
      changeIsContinueClickedInOfferModalSuccess,
    } = this.props;
    const authConfig = redisCommonData.NEW_AUTH_CONFIG
      ? JSON.parse(redisCommonData.NEW_AUTH_CONFIG)
      : {};
    const { offerCategory, defaultCategory, formConfig, unlockSuccessConfig } = offerConfig || {};
    const progressTitle = {
      1: SELECT_OFFER,
      2: WHO_ARE_YOU_SHOPPING_FOR,
      3: LAST_STEP_ENTER_OTP,
    }[step];
    const totalStep = login ? '2' : '3';
    return (
      <div className="offer-container">
        {!isDesktop && step !== 4 && !this.pdpFlow && (
          <ProgressBar step={step} title={progressTitle} totalStep={totalStep} />
        )}
        {this.pdpFlow && offerItem && step !== 4 && (
          <OfferItem currencyMark={currencyMark} dataLocale={dataLocale} item={offerItem} />
        )}
        <React.Fragment>
          {
            {
              1: (
                <SelectOffer
                  dataLocale={dataLocale}
                  defaultCategory={defaultCategory}
                  offerCategory={offerCategory}
                  selectOffer={this.selectOffer}
                />
              ),
              2: !isDesktop && (
                <CampaignForm
                  checkUserExists={this.checkUserExistsFunc}
                  dataLocale={dataLocale}
                  formConfig={formConfig}
                  isUserExists={isUserExists}
                  login={login}
                  persistFormValue={persistFormValue}
                  saveUserDataLoading={saveUserDataLoading}
                  submitOfferForm={this.submitOfferForm}
                />
              ),
              3: !isDesktop && (
                <OtpVerification
                  offerFlow
                  authConfig={authConfig}
                  counterNotRequired="false"
                  history={history}
                  otpVerifySuccess={this.otpVerifySuccess}
                  phoneNumber={userPhone}
                  showLoginScreen={this.changeNumber}
                />
              ),
              4: (
                <OfferUnlockSuccess
                  changeIsContinueClickedInOfferModalSuccess={
                    changeIsContinueClickedInOfferModalSuccess
                  }
                  dataLocale={dataLocale}
                  isDesktop={isDesktop}
                  isDesktopPdp={isDesktopPdp}
                  isPdpFlow={this.pdpFlow}
                  offerConfig={offerConfig}
                  offerItem={offerItem}
                  selectedOffer={this.selectedOffer}
                  successConfig={unlockSuccessConfig}
                />
              ),
            }[step]
          }
        </React.Fragment>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    redisCommonData: state.common.redisCommonData,
    login: state.common.login,
    dataLocale: state.locale,
    loading: state.auth.loading,
    isUserExists: state.offerCampaign.isUserExists,
    campaignUserData: state.offerCampaign.campaignUserData,
    isFirstDealUser: state.offerCampaign.isFirstDealUser,
    userInfo: (state.common.userInfo && state.common.userInfo.result) || null,
    saveUserDataLoading: state.offerCampaign.saveUserDataLoading,
    currencyMark: state.common.currencyMark,
    localeInfo: state.common.localeInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendCampaignUserData: data => dispatch(sendCampaignUserData(data)),
    sendValidateOtp: data => dispatch(sendValidateOtp(data)),
    firstDealUserExists: data => dispatch(firstDealUserExists(data)),
    checkUserExists: data => dispatch(checkUserExists(data)),
    resetCampaignUserData: () => dispatch(resetCampaignUserData()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OfferCampaign);
